import React from 'react'

import GameBox from '../../containers/GameBox'
import { GridGame } from './types'

interface Props {
  games: GridGame[]
}

export function GameBoxes({ games }: Props) {
  return (
    <>
      {games.map(({ slug, size }: GridGame) => (
        <GameBox
          key={slug}
          slug={slug}
          size={size}
        />
      ))}
    </>
  )
}
